module.exports = __webpack_public_path__ + "static/img/samsung-svc.a9db6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/samsung-svc.jpg
// module id = CQfu
// module chunks = 0